import { useState } from "react";
import { estadoAvisosEnDispositivo, registrarNotificacionesPush } from "../../services/firebaseNotifications";
import MisTurnos from "../../features/servidores/MisTurnos";
import CambiarPassword from "../../shared/components/CambiarPassword";
import Marca from "../../shared/components/Marca";
import LimiteDeError from "../../shared/components/LimiteDeError";
import { botonPequeno } from "../../shared/estilos";

// Vista del servidor: sus próximos turnos en orden de fecha y, para cada reunión,
// con quién sirve y el programa (prédica y canciones).
function ServidorDashboard({ usuario, onLogout }) {
  const [cambiandoClave, setCambiandoClave] = useState(false);
  const miembroId = usuario?.miembro?.id ?? usuario?.miembro_id;
  const avisosIniciales = estadoAvisosEnDispositivo(miembroId);
  const [avisosActivos, setAvisosActivos] = useState(avisosIniciales === "activas");
  const [estadoPush, setEstadoPush] = useState(
    { bloqueadas: "Bloqueaste las notificaciones en este navegador. Actívalas desde la configuración del sitio." }[avisosIniciales] || ""
  );
  const [activandoPush, setActivandoPush] = useState(false);

  const activarAvisos = async () => {
    setActivandoPush(true);
    try {
      const resultado = await registrarNotificacionesPush(miembroId);
      setAvisosActivos(resultado.habilitado);
      setEstadoPush(resultado.habilitado ? "Listo: recibirás un aviso en este dispositivo cuando te asignen un turno." : resultado.motivo);
    } catch (e) {
      setEstadoPush(e?.message || "No se pudieron activar los avisos. Inténtalo nuevamente.");
    } finally {
      setActivandoPush(false);
    }
  };

  return (
    <div className="min-h-screen text-white">
      <header className="sticky top-0 z-20 border-b border-white/10 bg-black/70 backdrop-blur-md">
        <div className="mx-auto flex max-w-5xl flex-col gap-4 p-4 sm:flex-row sm:items-center sm:justify-between sm:p-5">
          <Marca lema="Servidores" />
          <div className="flex flex-wrap gap-2">
            {!avisosActivos && (
              <button onClick={activarAvisos} disabled={activandoPush || !miembroId} className={botonPequeno}>
                {activandoPush ? "Activando..." : "Activar avisos"}
              </button>
            )}
            <button onClick={() => setCambiandoClave(true)} className={botonPequeno}>Cambiar contraseña</button>
            <button onClick={onLogout} className={botonPequeno}>Salir</button>
          </div>
        </div>
      </header>

      <main className="pantalla mx-auto max-w-5xl p-4 sm:p-5">
        <LimiteDeError>
          <MisTurnos usuario={usuario} avisosActivos={avisosActivos} estadoPush={estadoPush} />
        </LimiteDeError>
      </main>

      {cambiandoClave && <CambiarPassword onCerrar={() => setCambiandoClave(false)} />}
    </div>
  );
}

export default ServidorDashboard;
